import type { ISerialize } from '@/objects/ISerialize';

export class CategoryGroupMap implements ISerialize {
    public CategoryId: number;

    public CategoryName: string | null;

    public RaceIDs: number[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { CategoryId?: number; CategoryName?: string | null; RaceIDs?: number[] }) {
        this.CategoryId = values.CategoryId ?? 0;

        this.CategoryName = values.CategoryName ?? '';

        this.RaceIDs = values.RaceIDs ?? [];
    }

    public serialize(): string {
        return (
            '{' +
            `"CategoryId": ${JSON.stringify(this.CategoryId)}` +
            ',' +
            `"CategoryName": ${JSON.stringify(this.CategoryName)}` +
            ',' +
            `"RaceIDs": [ ${this.RaceIDs.map((x) => JSON.stringify(x))} ]` +
            '}'
        );
    }

    /**
     * Creates an instance of CategoryGroupMap from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { CategoryId?: number; CategoryName?: string | null; RaceIDs?: number[] }): CategoryGroupMap {
        return new CategoryGroupMap(values);
    }

    public static _FromServerJson(json: any): CategoryGroupMap {
        return new CategoryGroupMap({ CategoryId: json.CategoryId, CategoryName: json.CategoryName ?? '', RaceIDs: json.RaceIDs });
    }

    /**
     * Creates an instance of CategoryGroupMap from another instance of CategoryGroupMap.
     * @param other The CategoryGroupMap you want to clone
     * @returns A cloned CategoryGroupMap
     */
    public static FromOther(other: CategoryGroupMap): CategoryGroupMap {
        return CategoryGroupMap._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return CategoryGroupMap.FromOther(this);
    }

    static NAME_OF_CLASS = 'CategoryGroupMap';
}
